import { useAppDispatch, useAppSelector } from "store";
import { filesDirtySelector, sandboxActionInvoked, selectCurrentUser } from "store/features";
import { createForkToast, publicEditDisabledToast } from "components/toasts/Toasts";
import { sampleUserId } from "configuration";
import { useEffect } from "react";


interface EditorAlertsOptions {
  children: React.ReactNode;
}

export const EditorAlerts = ({ children }: EditorAlertsOptions) => {
  const showActionToasts = useAppSelector((state) => state.settings.global.showActionToasts);
  const updatePending = useAppSelector(filesDirtySelector);
  const user = useAppSelector(selectCurrentUser);
  const sandbox = useAppSelector((state) => state.activeSandbox.metadata);

  const dispatch = useAppDispatch();

  useEffect(() => {
    // User is not signed in, but is making code changes.
    if (showActionToasts && updatePending && !user?.id) {
      publicEditDisabledToast();
    }

    // User is not owner of the sandbox and not Bentley user, but is making code changes.
    if (showActionToasts && updatePending && user?.id && sandbox?.userId && sandbox?.name && sandbox?.id && user.id !== sandbox?.userId && !user.isBentleyUser) {
      publicEditDisabledToast();
    }

    // User is not owner of the sandbox, but is making code changes. Show warning to asking to fork
    if (showActionToasts && updatePending && user?.id && sandbox?.userId && sandbox?.name && sandbox?.id && user.id !== sandbox?.userId && user.isBentleyUser) {
      if (process.env.NODE_ENV === "development" && sandbox?.userId === sampleUserId) {
        // don't show fork toast for Sample Sandboxes in development environment
      } else {
        createForkToast(sandbox.name, () => dispatch(sandboxActionInvoked({
          type: "fork", args: {
            userId: sandbox.userId,
            sandboxId: sandbox.id
          }
        })));
      }
    }
  }, [showActionToasts, updatePending, user?.id, sandbox?.userId, sandbox?.name, sandbox?.id]);


  return <>{children}</>
}